import {Cureus} from '../Cureus';

Cureus.DeferralReasons= {};
//= require_tree ./DeferralReasons